<div class="applicant-identity">
  <h3 class="section-title mb-3">{{ 'fundApplication.applicantInformationTitle' | translate }}</h3>

  <form [formGroup]="form">
    <div class="p-fluid grid applicant-fields">
      <div class="field col-12 md:col-4">
        <label for="arabicFullName">{{ 'fundApplication.fullNameAr' | translate }} <span class="input-star">*</span></label>
        <input
          pInputText
          id="arabicFullName"
          type="text"
          formControlName="arabicFullName"
          class="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('arabicFullName') }"
        />
        <small *ngIf="form.get('arabicFullName')?.hasError('required') && isFieldInvalid('arabicFullName')" class="p-error">
          {{ 'Shared.REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('arabicFullName')?.hasError('fourWords') && isFieldInvalid('arabicFullName')" class="p-error">
          {{ 'step2.fullNameInvalid' | translate }}
        </small>
      </div>
      <div class="field col-12 md:col-4">
        <label for="englishFullName">{{ 'fundApplication.fullNameEn' | translate }}</label>
        <input
          pInputText
          id="englishFullName"
          type="text"
          formControlName="englishFullName"
          class="w-full"
        />
      </div>
      <div class="field col-12 md:col-4">
        <label for="nationalId">{{ 'fundApplication.nationalId' | translate }} <span class="input-star">*</span></label>
        <input
          pInputText
          id="nationalId"
          type="text"
          formControlName="nationalId"
          class="w-full"
          maxlength="10"
          (input)="onNationalIdInput()"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('nationalId') }"
        />
        <small *ngIf="form.get('nationalId')?.hasError('required') && isFieldInvalid('nationalId')" class="p-error">
          {{ 'Shared.REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('nationalId')?.hasError('saudiNid') && isFieldInvalid('nationalId')" class="p-error">
          {{ 'step2.nidInvalid' | translate }}
        </small>
      </div>

      <div class="field col-12 md:col-4">
        <label>{{ 'fundApplication.dateOfBirth' | translate }} <span class="input-star">*</span></label>
        <ng-container *ngIf="isDetails; else dobEditableBlock">
          <div class="tal-readonly-dob" aria-readonly="true">{{ formattedDobReadOnly }}</div>
        </ng-container>
        <ng-template #dobEditableBlock>
          <div class="date-type-selector mb-2" *ngIf="allowDateTypeSelection">
            <mat-button-toggle-group [value]="dateType" [disabled]="identityLockedExceptDesignation">
              <mat-button-toggle value="hijri" (click)="setDateType('hijri')">
                {{ 'Login.HIJRI_DATE' | translate }}
              </mat-button-toggle>
              <mat-button-toggle value="gregorian" (click)="setDateType('gregorian')">
                {{ 'Login.GREGORIAN_DATE' | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <p-calendar
            #birthdateCalendar
            *ngIf="dateType === 'gregorian'"
            inputId="dob"
            [ngModel]="gregorianDateModel"
            (ngModelChange)="onGregorianPickerChange($event)"
            (onShow)="onGregorianCalendarShow(birthdateCalendar)"
            [ngModelOptions]="{ standalone: true }"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [monthNavigator]="true"
            [yearNavigator]="true"
            [yearRange]="dobYearRange"
            [maxDate]="maxBirthDate"
            [readonlyInput]="true"
            [disabled]="identityLockedExceptDesignation"
            [showButtonBar]="true"
            appendTo="body"
            styleClass="w-full tal-gregorian-datepicker"
            inputStyleClass="form-control"
            [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('dob') }"
          ></p-calendar>

          <app-hijri-calendar
            *ngIf="dateType === 'hijri'"
            formControlName="dob"
            [lang]="languageService.currentLanguage === 'en' ? 'en' : 'ar'"
            [maxDate]="maxBirthDate"
          ></app-hijri-calendar>
          <small *ngIf="form.get('dob')?.hasError('required') && isFieldInvalid('dob')" class="p-error">
            {{ 'Shared.REQUIRED' | translate }}
          </small>
          <small *ngIf="form.get('dob')?.hasError('future') && isFieldInvalid('dob')" class="p-error">
            {{ 'step2.birthFuture' | translate }}
          </small>
          <small *ngIf="form.get('dob')?.hasError('minAge') && isFieldInvalid('dob')" class="p-error">
            {{ 'step2.birthMinAge' | translate }}
          </small>
        </ng-template>
      </div>
      <div class="field col-12 md:col-4">
        <label for="mobile">{{ 'fundApplication.phone' | translate }} <span class="input-star">*</span></label>
        <input
          pInputText
          id="mobile"
          type="tel"
          formControlName="mobile"
          class="w-full"
          maxlength="9"
          (input)="onMobileInput()"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('mobile') }"
        />
        <small *ngIf="form.get('mobile')?.hasError('required') && isFieldInvalid('mobile')" class="p-error">
          {{ 'Shared.REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('mobile')?.hasError('pattern') && isFieldInvalid('mobile')" class="p-error">
          {{ 'step3.phoneNumberInvalid' | translate }}
        </small>
      </div>
      <div class="field col-12 md:col-4">
        <label for="designation"
          >{{ 'authorizedPerson.designation' | translate }} <span class="input-star">*</span></label
        >
        <p-dropdown
          inputId="designation"
          [options]="designations"
          formControlName="designation"
          optionLabel="label"
          optionValue="value"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('designation') }"
          [placeholder]="'common.select' | translate"
          styleClass="w-full"
        ></p-dropdown>
        <small *ngIf="isFieldInvalid('designation')" class="p-error">{{ 'Shared.REQUIRED' | translate }}</small>
      </div>
    </div>
  </form>
</div>
